/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
const getAllParentKeys = (input: string) => {
  const parts = input?.split("-");
  const result: string[] = [];

  parts?.reduce((accumulator, currentValue) => {
    const newSubstring = accumulator
      ? `${accumulator}-${currentValue}`
      : currentValue;
    result.push(newSubstring);
    return newSubstring;
  }, "");

  return result;
};
export default getAllParentKeys;
